<template>
    <div class="flex column gap-20">
        <div class="section w-full flex column"> 
            <span class="section-header yes-no">7. Additinal Information<br>
                Note: A PEP is a natural person who is or has been entrusted with a prominent public function <br>and includes his immediate family members or persons known to be close associates of such persons.
            </span>
            
            <table class="info-table w-full">
                <tr v-if="changes">
                    <th></th>
                    <td colspan="2" class="title-change"><b>Previous Version</b></td>
                    <td colspan="2" class="title-change"><b>New Version</b></td>
                </tr>
                <tr>
                    <th class="width-big"></th>
                    <td class="small text-center">YES</td>
                    <td class="small text-center">NO</td>
                    <td v-if="changes" class="small text-center">YES</td>
                    <td v-if="changes" class="small text-center">NO</td>
                </tr>
                <tr>
                    <th :rowspan="peps_present_current ? 2 : 1">Are there any PEPs identified in the Company?
                        <br><br>
                        If yes, please provide the following details: <br>
                        a) Full Name; <br>
                        b) Passport number; <br>
                        c) Public office description;<br>
                        d) Role or type of PEP - relation and coutnry;<br>
                        e) Date when office was assumed/left<br><br>
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.peps_present?.error,
                            'current changes': changes?.peps_present?.new != undefined && changes?.peps_present?.current && changes?.peps_present?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-peps_present_" 
                            style="margin: 0 5px"
                            name="peps_present_"
                            :checked="getCurrentValue('peps_present') == 'YES'"
                            value="YES"
                            :disabled="!editable"
                            @change="handleChange('peps_present', 'YES')"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.peps_present?.error,
                            'current changes': changes?.peps_present?.new != undefined && changes?.peps_present?.current && changes?.peps_present?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-peps_present_" 
                            style="margin: 0 5px"
                            name="peps_present_"
                            :checked="getCurrentValue('peps_present') == 'NO'"
                            value="NO" 
                            @change="handleChange('peps_present', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.peps_present?.error" class="text-red-500 text-left">
                            {{ mainInfo?.peps_present?.error }}
                        </div>
                    </td>
                    <td v-if="changes" class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.peps_present?.error,
                            'new-value changes': changes?.peps_present?.new != undefined && changes?.peps_present?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-peps_present" 
                            style="margin: 0 5px"
                            name="peps_present"
                            :checked="getFieldValue('peps_present', 'new') == 'YES'"
                            value="YES"
                            :disabled="true"
                        >
                    </td>
                    <td v-if="changes" 
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.peps_present?.error,
                            'new-value changes': changes?.peps_present?.new != undefined && changes?.peps_present?.new == 'NO'
                        }">
                    
                        <input 
                            type="radio" 
                            id="NO-peps_present" 
                            style="margin: 0 5px"
                            name="peps_present"
                            :checked="getFieldValue('peps_present', 'new') == 'NO'"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>
                <tr v-if="peps_present_current || getFieldValue('peps_present', 'new') === 'YES'">
                    <td colspan="2" >
                        <CommentSection 
                            attrId='peps_present_details' 
                            class="markdown-content" 
                            :class="{
                                'disabled' : !editable,
                                'border-error': mainInfo?.peps_present_details?.error,
                                'current changes': changes?.peps_present_details?.new != undefined && changes?.peps_present_details?.current
                            }"
                            :disabled="!editable"
                            :commentSection="getCurrentValue('peps_present_details')"
                            @changeinput="quillContentComment" 
                            
                        />
                        <div v-if="mainInfo?.peps_present_details?.error" class="text-red-500 text-left">
                            {{ mainInfo?.peps_present_details?.error }}
                        </div>
                    </td>
                    <td colspan="2" v-if="changes">
                        <CommentSection 
                            attrId='peps_present_details_' 
                            class="markdown-content" 
                            :class="{
                                'disabled' : true,
                                'new-value changes': changes?.peps_present_details?.new != undefined
                            }"
                            :disabled="true"
                            :commentSection="getFieldValue('peps_present_details', 'new')"
                        />
                     
                    </td>
                </tr>
                <tr>
                    <th class="width-big" :rowspan="getCurrentValue('interesting_past') == 'YES' || past_present_new ? 2 : 1"> Is there any information about the custome or director/s shareholder/s past or present, that may lead to concern for the Company ?
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.peps_present?.error,
                            'current changes': changes?.interesting_past?.new != undefined && changes?.interesting_past?.current && changes?.interesting_past?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-interesting_past" 
                            style="margin: 0 5px"
                            name="interesting_past"
                            :checked="getCurrentValue('interesting_past') == 'YES'"
                            value="YES" 
                            @change="handleChange('interesting_past', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.interesting_past?.error,
                            'current changes': changes?.interesting_past?.new != undefined && changes?.interesting_past?.current && changes?.interesting_past?.current == 'NO'
                        }">
                    
                        <input 
                            type="radio" 
                            id="NO-interesting_past" 
                            style="margin: 0 5px"
                            name="interesting_past"
                            :checked="getCurrentValue('interesting_past') == 'NO'"
                            value="NO" 
                            @change="handleChange('interesting_past', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.interesting_past?.error" class="text-red-500 text-left">
                            {{ mainInfo?.interesting_past?.error }}
                        </div>
                    </td>
                    <td v-if="changes" class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.interesting_past?.error,
                            'new-value changes': changes?.interesting_past?.new != undefined && changes?.interesting_past?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-interesting_past_" 
                            style="margin: 0 5px"
                            name="interesting_past_"
                            :checked="getFieldValue('interesting_past', 'new') == 'YES'"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>
                    <td v-if="changes" class="small"
                        :class="{
                            'border border-red-500': mainInfo?.interesting_past?.error,
                            'new-value changes': changes?.interesting_past?.new != undefined && changes?.interesting_past?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-interesting_past_" 
                            style="margin: 0 5px"
                            name="interesting_past_"
                            :checked="getFieldValue('interesting_past', 'new') == 'NO'"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>
                <tr v-if="past_present_current || getFieldValue('interesting_past', 'new')">
                    <td colspan="2">
                        <CommentSection 
                            attrId='interesting_past_details' 
                            class="markdown-content" 
                            :class="{
                                'disabled' : !editable,
                                'border-error': mainInfo?.interesting_past_details?.error,
                                'current changes': changes?.interesting_past_details?.new != undefined && changes?.interesting_past_details?.current

                            }"
                            :disabled="!editable"
                            :commentSection="getCurrentValue('interesting_past_details')"
                            @changeinput="quillContentComment" 
                        />
                        <div v-if="mainInfo?.interesting_past_details?.error" class="text-red-500 text-left">
                            {{ mainInfo?.interesting_past_details?.error }}
                        </div>
                    </td>
                    <td colspan="2" v-if="changes">
                        <CommentSection 
                            attrId='interesting_past_details_' 
                            class="markdown-content" 
                            :class="{
                                'disabled' : true,
                                'new-value changes': changes?.interesting_past_details?.new != undefined
                            }"
                            :disabled="true"
                            :commentSection="getFieldValue('interesting_past_details', 'new')"
                        />
                    </td>
                </tr>
            </table>
        </div>

        <div class="section w-full flex column"> 
            <span class="section-header yes-no">8. AML & Compliance Statement Compliance<br>
            </span>
            <table class="info-table w-full">
                <tr v-if="changes">
                    <th></th>
                    <td colspan="2" class="title-change"><b>Previous Version</b></td>
                    <td colspan="2" class="title-change"><b>New Version</b></td>
                </tr>
                <tr>
                    <th class="width-big"></th>
                    <td class="small text-center">YES</td>
                    <td class="small text-center">NO</td>
                    <td v-if="changes" class="small text-center">YES</td>
                    <td v-if="changes" class="small text-center">NO</td>
                </tr>
                <tr>
                    <th class="width-big">Does the entity maintain an internal AML Policy? </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.internal_aml_policy?.error,
                            'current changes': changes?.internal_aml_policy?.new != undefined && changes?.internal_aml_policy?.current && changes?.internal_aml_policy?.current == 'YES'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="YES-internal_aml_policy" 
                            style="margin: 0 5px"
                            name="internal_aml_policy"
                            :checked="getCurrentValue('internal_aml_policy') == 'YES'"
                            value="YES"
                            :disabled="!editable"
                            @change="handleChange('internal_aml_policy', 'YES')"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.internal_aml_policy?.error,
                            'current changes': changes?.internal_aml_policy?.new != undefined && changes?.internal_aml_policy?.current && changes?.internal_aml_policy?.current == 'NO'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="NO-internal_aml_policy" 
                            style="margin: 0 5px"
                            name="internal_aml_policy"
                            :checked="getCurrentValue('internal_aml_policy') == 'NO'"
                            value="NO" 
                            @change="handleChange('internal_aml_policy', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.internal_aml_policy?.error" class="text-red-500 text-left">
                            {{ mainInfo?.internal_aml_policy?.error }}
                        </div>
                    </td>
                    <td v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.internal_aml_policy?.error,
                            'new-value changes': changes?.internal_aml_policy?.new != undefined && changes?.internal_aml_policy?.new == 'YES'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="YES-internal_aml_policy" 
                            style="margin: 0 5px"
                            name="internal_aml_policy_"
                            :checked="getFieldValue('internal_aml_policy', 'new') == 'YES'"
                            value="YES"
                            :disabled="true"
                        >
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.internal_aml_policy?.error,
                            'new-value changes': changes?.internal_aml_policy?.new != undefined && changes?.internal_aml_policy?.new == 'NO'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="NO-internal_aml_policy" 
                            style="margin: 0 5px"
                            name="internal_aml_policy_"
                            :checked="getFieldValue('internal_aml_policy', 'new') == 'NO'"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>
                <tr>
                    <th class="width-big">Is there an appointed MLRO/Compliance Officer? 
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.compliance_officer_present?.error,
                            'current changes': changes?.compliance_officer_present?.new != undefined && changes?.compliance_officer_present?.current && changes?.compliance_officer_present?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-compliance_officer_present" 
                            style="margin: 0 5px"
                            name="compliance_officer_present"
                            :checked="getCurrentValue('compliance_officer_present') == 'YES'"
                            value="YES" 
                            @change="handleChange('compliance_officer_present', 'YES')"
                            :disabled="!editable"
                        >
                        
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.compliance_officer_present?.error,
                            'current changes': changes?.compliance_officer_present?.new != undefined && changes?.compliance_officer_present?.current && changes?.compliance_officer_present?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-compliance_officer_present" 
                            style="margin: 0 5px"
                            name="compliance_officer_present"
                            :checked="getCurrentValue('compliance_officer_present') == 'NO'"
                            value="NO" 
                            @change="handleChange('compliance_officer_present', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.compliance_officer_present?.error" class="text-red-500 text-left">
                            {{ mainInfo?.compliance_officer_present?.error }}
                        </div>
                    </td>

                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.compliance_officer_present?.error,
                            'new-value changes': changes?.compliance_officer_present?.new != undefined && changes?.compliance_officer_present?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-compliance_officer_present" 
                            style="margin: 0 5px"
                            name="compliance_officer_present_"
                            :checked="getFieldValue('compliance_officer_present', 'new') == 'YES'"
                            value="YES" 
                            :disabled="true"
                        >
                        
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.compliance_officer_present?.error,
                            'new-value changes': changes?.compliance_officer_present?.new != undefined && changes?.compliance_officer_present?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-compliance_officer_present" 
                            style="margin: 0 5px"
                            name="compliance_officer_present_"
                            :checked="getFieldValue('compliance_officer_present', 'new') == 'NO'"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>
                <tr v-if="getFieldValue('compliance_officer_present', 'new') || (
                        getCurrentValue('compliance_officer_present') == 'YES' 
                    )">
                    <th>Name & Contact of MLRO  Name:</th>
                    <td colspan="2">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getCurrentValue('compliance_officer_name')"
                            key_ref="compliance_officer_name" 
                            type="text" 
                            class='current'
                            :class="{'changes': changes?.compliance_officer_name?.new != undefined && changes?.compliance_officer_name?.current}"
                            placeholder="" 
                            :error="mainInfo?.compliance_officer_name?.error"
                            :disabled="!editable"
                        />
                    </td>
                    <td colspan="2" v-if="changes">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getFieldValue('compliance_officer_name', 'new')"
                            type="text" 
                            class='new-value'
                            :class="{'changes': changes?.compliance_officer_name?.new != undefined}"
                            :disabled="true"
                        />
                    </td>
                </tr>
                <tr v-if="getFieldValue('compliance_officer_present', 'new') || getCurrentValue('compliance_officer_present') == 'YES'">
                    <th>Contact email address:</th>
                    <td colspan="2">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getCurrentValue('compliance_officer_email')"
                            key_ref="compliance_officer_email" 
                            type="text" 
                            class='current'
                            :class="{'changes': changes?.compliance_officer_email?.new != undefined && changes?.compliance_officer_email?.current}"
                            placeholder="" 
                            :error="mainInfo?.compliance_officer_email?.error"
                            :disabled="!editable"
                        />
                    </td>
                    <td colspan="2" v-if="changes">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getFieldValue('compliance_officer_email', 'new')"
                            type="text" 
                            class='new-value'
                            :class="{'changes': changes?.compliance_officer_email?.new != undefined}"
                            :disabled="true"
                        />
                    </td>
                </tr>
                <tr v-if="getFieldValue('compliance_officer_present', 'new') || getCurrentValue('compliance_officer_present') == 'YES'">
                    <th>Contact number:</th>
                    <td colspan="2">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getCurrentValue('compliance_officer_phone')"
                            key_ref="compliance_officer_phone" 
                            type="text" 
                            class='current'
                            :class="{'changes': changes?.compliance_officer_phone?.new != undefined && changes?.compliance_officer_phone?.current}"
                            placeholder="" 
                            :error="mainInfo?.compliance_officer_phone?.error"
                            :disabled="!editable"
                        />
                    </td>
                    <td colspan="2" v-if="changes">
                        <InpComponent 
                            @inputChange="inputChangeFunc"
                            :value="getFieldValue('compliance_officer_phone', 'new')"
                            type="text" 
                            class='new-value'
                            :class="{'changes': changes?.compliance_officer_phone?.new != undefined && changes?.compliance_officer_phone?.current}"
                            placeholder="" 
                            :disabled="true"
                        />
                    </td>
                </tr>
                <tr>
                    <th class="width-big">
                        Does the entity perform customer KYC? 
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.has_customer_kyc?.error,
                            'current changes': changes?.has_customer_kyc?.new != undefined && changes?.has_customer_kyc?.current && changes?.has_customer_kyc?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-has_customer_kyc" 
                            :checked="getCurrentValue('has_customer_kyc') == 'YES'"
                            style="margin: 0 5px"
                            name="has_customer_kyc"
                            value="YES" 
                            @change="handleChange('has_customer_kyc', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.has_customer_kyc?.error,
                            'current changes': changes?.has_customer_kyc?.new != undefined && changes?.has_customer_kyc?.current && changes?.has_customer_kyc?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-has_customer_kyc" 
                            :checked="getCurrentValue('has_customer_kyc') == 'NO'"
                            style="margin: 0 5px"
                            name="has_customer_kyc"
                            value="NO" 
                            @change="handleChange('has_customer_kyc', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.has_customer_kyc?.error" class="text-red-500 text-left">
                            {{ mainInfo?.has_customer_kyc?.error }}
                        </div>
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.has_customer_kyc?.error,
                            'new-value changes': changes?.has_customer_kyc?.new != undefined && changes?.has_customer_kyc?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-has_customer_kyc" 
                            :checked="getFieldValue('has_customer_kyc', 'new') == 'YES'"
                            style="margin: 0 5px"
                            name="has_customer_kyc_"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.has_customer_kyc?.error,
                            'new-value changes': changes?.has_customer_kyc?.new != undefined && changes?.has_customer_kyc?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-has_customer_kyc" 
                            :checked="getFieldValue('has_customer_kyc', 'new') == 'NO'"
                            style="margin: 0 5px"
                            name="has_customer_kyc_"
                            value="NO" 
                            :disabled="true"
                        >
                      
                    </td>
                </tr>

                <tr>
                    <th class="width-big">
                        Is customer’s PEP screening conducted?
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_pep_conducted?.error,
                            'current changes': changes?.customer_pep_conducted?.new != undefined && changes?.customer_pep_conducted?.current && changes?.customer_pep_conducted?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-customer_pep_conducted" 
                            :checked="getCurrentValue('customer_pep_conducted') == 'YES'"
                            style="margin: 0 5px"
                            name="customer_pep_conducted"
                            value="YES" 
                            @change="handleChange('customer_pep_conducted', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_pep_conducted?.error,
                            'current changes': changes?.customer_pep_conducted?.new != undefined && changes?.customer_pep_conducted?.current && changes?.customer_pep_conducted?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-customer_pep_conducted" 
                            :checked="getCurrentValue('customer_pep_conducted') == 'NO'"
                            style="margin: 0 5px"
                            name="customer_pep_conducted"
                            value="NO" 
                            @change="handleChange('customer_pep_conducted', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.customer_pep_conducted?.error" class="text-red-500 text-left">
                            {{ mainInfo?.customer_pep_conducted?.error }}
                        </div>
                    </td>

                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_pep_conducted?.error,
                            'new-value changes': changes?.customer_pep_conducted?.new != undefined && changes?.customer_pep_conducted?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-customer_pep_conducted" 
                            :checked="getFieldValue('customer_pep_conducted', 'new') == 'YES'"
                            style="margin: 0 5px"
                            name="customer_pep_conducted_"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_pep_conducted?.error,
                            'new-value changes': changes?.customer_pep_conducted?.new != undefined && changes?.customer_pep_conducted?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-customer_pep_conducted" 
                            :checked="getFieldValue('customer_pep_conducted', 'new') == 'NO'"
                            style="margin: 0 5px"
                            name="customer_pep_conducted_"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>

                </tr>

                <tr>
                    <th class="width-big">
                        Is customer’s transaction monitoring conducted?  
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_transaction_monitoring?.error,
                            'current changes': changes?.customer_transaction_monitoring?.new != undefined && changes?.customer_transaction_monitoring?.current && changes?.customer_transaction_monitoring?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-customer_transaction_monitoring" 
                            :checked="getCurrentValue('customer_transaction_monitoring') == 'YES'"
                            style="margin: 0 5px"
                            name="customer_transaction_monitoring"
                            value="YES" 
                            @change="handleChange('customer_transaction_monitoring', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_transaction_monitoring?.error,
                            'current changes': changes?.customer_transaction_monitoring?.new != undefined && changes?.customer_transaction_monitoring?.current && changes?.customer_transaction_monitoring?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-customer_transaction_monitoring" 
                            :checked="getCurrentValue('customer_transaction_monitoring') == 'NO'"
                            style="margin: 0 5px"
                            name="customer_transaction_monitoring"
                            value="NO" 
                            @change="handleChange('customer_transaction_monitoring', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.customer_transaction_monitoring?.error" class="text-red-500 text-left">
                            {{ mainInfo?.customer_transaction_monitoring?.error }}
                        </div>
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_transaction_monitoring?.error,
                            'new-value changes': changes?.customer_transaction_monitoring?.new != undefined && changes?.customer_transaction_monitoring?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-customer_transaction_monitoring" 
                            :checked="getFieldValue('customer_transaction_monitoring', 'new') == 'YES'"
                            style="margin: 0 5px"
                            name="customer_transaction_monitoring_"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.customer_transaction_monitoring?.error,
                            'new-value changes': changes?.customer_transaction_monitoring?.new != undefined && changes?.customer_transaction_monitoring?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-customer_transaction_monitoring" 
                            :checked="getFieldValue('customer_transaction_monitoring', 'new') == 'NO'"
                            style="margin: 0 5px"
                            name="customer_transaction_monitoring_"
                            value="NO" 
                            :disabled="true"
                        >
                      
                    </td>
                </tr>


                <tr>
                    <th class="width-big">
                        Are suspicious transactions reported to the authorities?  	
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.suspicious_activity_reported?.error,
                            'current changes': changes?.suspicious_activity_reported?.new != undefined && changes?.suspicious_activity_reported?.current && changes?.suspicious_activity_reported?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-suspicious_activity_reported" 
                            :checked="getCurrentValue('suspicious_activity_reported') == 'YES'"
                            style="margin: 0 5px"
                            name="suspicious_activity_reported"
                            value="YES" 
                            @change="handleChange('suspicious_activity_reported', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.suspicious_activity_reported?.error,
                            'current changes': changes?.suspicious_activity_reported?.new != undefined && changes?.suspicious_activity_reported?.current && changes?.suspicious_activity_reported?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-suspicious_activity_reported" 
                            :checked="getCurrentValue('suspicious_activity_reported') == 'NO'"
                            style="margin: 0 5px"
                            name="suspicious_activity_reported"
                            value="NO" 
                            @change="handleChange('suspicious_activity_reported', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.suspicious_activity_reported?.error" class="text-red-500 text-left">
                            {{ mainInfo?.suspicious_activity_reported?.error }}
                        </div>
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.suspicious_activity_reported?.error,
                            'new-value changes': changes?.suspicious_activity_reported?.new != undefined && changes?.suspicious_activity_reported?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-suspicious_activity_reported" 
                            :checked="getFieldValue('suspicious_activity_reported', 'new') == 'YES'"
                            style="margin: 0 5px"
                            name="suspicious_activity_reported_"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>

                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.suspicious_activity_reported?.error,
                            'new-value changes': changes?.suspicious_activity_reported?.new != undefined && changes?.suspicious_activity_reported?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-suspicious_activity_reported" 
                            :checked="getFieldValue('suspicious_activity_reported', 'new') == 'NO'"
                            style="margin: 0 5px"
                            name="suspicious_activity_reported_"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>

            </table>
        </div>


        <div class="section w-full flex column"> 
            <span class="section-header yes-no">9. FATCA<br>
            </span>
            <table class="info-table w-full">
                <tr v-if="changes">
                    <th></th>
                    <td colspan="2" class="title-change"><b>Previous Version</b></td>
                    <td colspan="2" class="title-change"><b>New Version</b></td>
                </tr>
                <tr>
                    <th class="width-big"></th>
                    <td class="small text-center">YES</td>
                    <td class="small text-center">NO</td>
                    <td v-if="changes" class="small text-center">YES</td>
                    <td v-if="changes" class="small text-center">NO</td>
                </tr>
                <tr>
                    <th class="width-big">Is the applicant for business a U.S. Entity?</th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant?.error,
                            'current changes': changes?.us_applicant?.new != undefined && changes?.us_applicant?.current && changes?.us_applicant?.current == 'YES'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="YES-us_applicant" 
                            style="margin: 0 5px"
                            name="us_applicant"
                            :checked="getCurrentValue('us_applicant') == 'YES'"
                            value="YES"
                            :disabled="!editable"
                            @change="handleChange('us_applicant', 'YES')"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant?.error,
                            'current changes': changes?.us_applicant?.new != undefined && changes?.us_applicant?.current && changes?.us_applicant?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant" 
                            style="margin: 0 5px"
                            name="us_applicant"
                            :checked="getCurrentValue('us_applicant') == 'NO'"
                            value="NO" 
                            @change="handleChange('us_applicant', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.us_applicant?.error" class="text-red-500 text-left">
                            {{ mainInfo?.us_applicant?.error }}
                        </div>
                    </td>

                    <td v-if="changes" 
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant?.error,
                            'new-value changes': changes?.us_applicant?.new != undefined & changes?.us_applicant?.new == 'YES'
                        }"
                        >
                        <input 
                            type="radio" 
                            id="YES-us_applicant" 
                            style="margin: 0 5px"
                            name="us_applicant_"
                            :checked="getFieldValue('us_applicant', 'new') == 'YES'"
                            value="YES"
                            :disabled="!editable"
                            @change="handleChange('us_applicant', 'YES')"
                        >
                    </td>

                    <td v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant?.error,
                            'new-value changes': changes?.us_applicant?.new != undefined && changes?.us_applicant?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant" 
                            style="margin: 0 5px"
                            name="us_applicant_"
                            :checked="getFieldValue('us_applicant', 'new') == 'NO'"
                            value="NO" 
                            @change="handleChange('us_applicant', 'NO')"
                            :disabled="!editable"
                        >
                    </td>
                </tr>

                <tr>
                    <th class="width-big">Is the income of the applicant for
                        business effectively connected with the
                        conduct of a trade or business in the
                        United States?
                    </th>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_connect?.error,
                            'current changes': changes?.us_applicant_connect?.new != undefined && changes?.us_applicant_connect?.current && changes?.us_applicant_connect?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-us_applicant_connect" 
                            style="margin: 0 5px"
                            name="us_applicant_connect"
                            :checked="getCurrentValue('us_applicant_connect') == 'YES'"
                            value="YES" 
                            @change="handleChange('us_applicant_connect', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_connect?.error,
                            'current changes': changes?.us_applicant_connect?.new != undefined && changes?.us_applicant_connect?.current && changes?.us_applicant_connect?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant_connect" 
                            style="margin: 0 5px"
                            name="us_applicant_connect"
                            :checked="getCurrentValue('us_applicant_connect') == 'NO'"
                            value="NO" 
                            @change="handleChange('us_applicant_connect', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.us_applicant_connect?.error" class="text-red-500 text-left">
                            {{ mainInfo?.us_applicant_connect?.error }}
                        </div>
                    </td>


                    <td v-if="changes" class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_connect?.error,
                            'new-value changes': changes?.us_applicant_connect?.new != undefined  && changes?.us_applicant_connect?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-us_applicant_connect" 
                            style="margin: 0 5px"
                            name="us_applicant_connect_"
                            :checked="getFieldValue('us_applicant_connect', 'new') == 'YES'"
                            value="YES" 
                            :disabled="true"
                        >
                    </td>
                    <td v-if="changes" class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_connect?.error,
                            'new-value changes': changes?.us_applicant_connect?.new != undefined && changes?.us_applicant_connect?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant_connect" 
                            style="margin: 0 5px"
                            name="us_applicant_connect_"
                            :checked="getFieldValue('us_applicant_connect', 'new') == 'NO'"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>


                </tr>

                <tr>
                    <th class="width-big">
                        Is the income of the applicant for
                        business effectively connected but is not
                        subject to tax under an applicable income
                        tax treaty?
                    </th>
                    
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_tag_related?.error,
                            'current changes': changes?.us_applicant_tag_related?.new != undefined && changes?.us_applicant_tag_related?.current && changes?.us_applicant_tag_related?.current == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-us_applicant_tag_related" 
                            :checked="getCurrentValue('us_applicant_tag_related') == 'YES'"
                            style="margin: 0 5px"
                            name="us_applicant_tag_related"
                            value="YES" 
                            @change="handleChange('us_applicant_tag_related', 'YES')"
                            :disabled="!editable"
                        >
                    </td>
                    <td class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_tag_related?.error,
                            'current changes': changes?.us_applicant_tag_related?.new != undefined && changes?.us_applicant_tag_related?.current && changes?.us_applicant_tag_related?.current == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant_tag_related" 
                            :checked="getCurrentValue('us_applicant_tag_related') == 'NO'"
                            style="margin: 0 5px"
                            name="us_applicant_tag_related"
                            value="NO" 
                            @change="handleChange('us_applicant_tag_related', 'NO')"
                            :disabled="!editable"
                        >
                        <div v-if="mainInfo?.us_applicant_tag_related?.error" class="text-red-500 text-left">
                            {{ mainInfo?.us_applicant_tag_related?.error }}
                        </div>
                    </td>

                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_tag_related?.error,
                            'new-value changes': changes?.us_applicant_tag_related?.new != undefined && changes?.us_applicant_tag_related?.new == 'YES'
                        }">
                        <input 
                            type="radio" 
                            id="YES-us_applicant_tag_related" 
                            :checked="getFieldValue('us_applicant_tag_related', 'new') == 'YES'"
                            style="margin: 0 5px"
                            name="us_applicant_tag_related_"
                            value="YES" 
                            @change="handleChange('us_applicant_tag_related', 'YES')"
                            :disabled="true"
                        >
                    </td>
                    <td 
                        v-if="changes"
                        class="small" 
                        :class="{
                            'border border-red-500': mainInfo?.us_applicant_tag_related?.error,
                            'new-value changes': changes?.us_applicant_tag_related?.new != undefined && changes?.us_applicant_tag_related?.new == 'NO'
                        }">
                        <input 
                            type="radio" 
                            id="NO-us_applicant_tag_related" 
                            :checked="getFieldValue('us_applicant_tag_related', 'new') == 'NO'"
                            style="margin: 0 5px"
                            name="us_applicant_tag_related_"
                            value="NO" 
                            :disabled="true"
                        >
                    </td>
                </tr>


            </table>
        </div>

        <div class="section w-full flex column"> 
            <span class="section-header">With My Signature, I state that <br><br>
                a. I am authorized to duly execute this questionnaire on behalf of the Company that is submitting this
                questionnaire. <br><br>
                b. I have personally supplied the information contained in this questionnaire. <br><br>
                c. I confirm, to the best of my knowledge, that all information supplied is correct.
            </span>
            <div class="w-full">
                <table class="info-table w-full">
                    <tr v-if="changes">
                    <th></th>
                    <td class="title-change"><b>Previous Version</b></td>
                    <td class="title-change"><b>New Version</b></td>
                </tr>
                    <tr>
                        <th>Full Name</th>
                        <td>
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getCurrentValue('filler_full_name')"
                                key_ref="filler_full_name" 
                                type="text" 
                                placeholder="" 
                                :error="mainInfo?.filler_full_name?.error"
                                :disabled="!editable"
                                class="current"
                                :class="{changes: changes?.filler_full_name?.new != undefined && changes?.filler_full_name?.current}"
                            />
                        </td>
                        <td v-if="changes">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getFieldValue('filler_full_name', 'new')"
                                key_ref="filler_full_name" 
                                type="text" 
                                class="new-value"
                                :class="{changes: changes?.filler_full_name?.new != undefined}"
                                :disabled="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Position</th>
                        <td>
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getCurrentValue('position')"
                                key_ref="position" 
                                type="text" 
                                placeholder="" 
                                :error="mainInfo.position?.error"
                                :disabled="!editable"
                                class="current"
                                :class="{changes: changes?.position?.new != undefined && changes?.position?.current}"
                            />
                        </td>
                        <td v-if="changes">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getFieldValue('position', 'new')"
                                key_ref="position" 
                                type="text" 
                                class="new-value"
                                :class="{changes: changes?.position?.new != undefined}"
                                :disabled="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Date when signed</th>
                        <td>
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getCurrentValue('date_when_signed')"
                                key_ref="date_when_signed" 
                                type="date" 
                                placeholder="" 
                                :error="mainInfo.date_when_signed?.error"
                                :disabled="!editable"
s                                class="current"
                                :class="{changes: changes?.date_when_signed?.new != undefined && changes?.date_when_signed?.current}"
                            />
                        </td>
                        <td v-if="changes">
                            <InpComponent 
                                @inputChange="inputChangeFunc"
                                :value="getFieldValue('date_when_signed', 'new')"
                                key_ref="date_when_signed" 
                                type="date" 
                                class="new-value"
                                :class="{changes: changes?.date_when_signed?.new != undefined}"
                                :disabled="true"
                            />
                        </td>
                    </tr>
                </table>
            </div>
        </div>
            
    </div>
</template>


<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import InpComponent from '@/components/InpComponent.vue';
import CommentSection from '@/views/CommentSection.vue';

const store = useStore();
const editable = false;

const props = defineProps(['changes', 'sourceObjectState']);

const mainInfo = computed(() => {
    return store.state.dueDiligenceRecord;
});
function getCurrentValue(field){
    if (!props.changes) {
        return mainInfo.value[field].new_value || mainInfo.value[field].value;
    }
    return props.sourceObjectState[field] 
}

function getFieldValue(field, state) {
    if (!props.changes) {
        return mainInfo.value[field].value;
    }
    if (
        state == 'current' && 
        props.changes[field] && 
        !props.changes[field].current && 
        props.changes[field].new
    ) {
        return null;
    }
    if (props.changes[field] && props.changes[field][state]) {
        return props.changes[field][state];
    }
    return mainInfo.value[field].value;
}

const peps_present_current = computed( () => {

    if (props.changes) {
        return getCurrentValue('peps_present') === 'YES';
    }

    if (mainInfo.value.peps_present.new_value === 'YES') {
        return true;
    }
    if (mainInfo.value.peps_present.new_value === 'NO') {
        return false;
    }
    if (mainInfo.value.peps_present.value === 'YES') {
        return true;
    }
    if (mainInfo.value.peps_present.value === 'NO') {
        return false;
    }
    return false
})

const peps_present_new = computed(() => {
    return props.changes && props.changes.peps_present && props.changes.peps_present.new == 'YES';
})

const past_present_new = computed(() => {
    return props.changes && props.changes.interesting_past && props.changes.interesting_past.new == 'YES';
})

const past_present_current = computed( () => {
    if (props.changes) {
        return getCurrentValue('past_present') === 'YES';
    }
    if (mainInfo.value.interesting_past.new_value === 'YES') {
        return true;
    }
    if (mainInfo.value.interesting_past.new_value === 'NO') {
        return false;
    }
    if (mainInfo.value.interesting_past.value === 'YES') {
        return true;
    }
    if (mainInfo.value.interesting_past.value === 'NO') {
        return false;
    }
    return false
})

</script>

<style scoped lang="scss">
    
    .missing-file {
        display: list-item;
        list-style-type: disc;
    }
    .missing-file::marker {
        font-size: 1.2rem;
    }

    .close-section {
        position: absolute;
        left: -15px;
        top: 20px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        display: flex;
        img {
            width: 30px;
        }

    }
    .notification-section {
        // overflow-y: auto;
        position: fixed;
        right: -300px;
        top: 60px;
        width: 300px;
        background: white;
        padding: 10px;
        padding-left: 20px;
        bottom: 0;
        border-left: 1px solid var(--border-color);
        border-top: 1px solid var(--border-color);
        transition: all 0.3s ease-in-out;
        box-sizing: border-box;
        
        .close-section {
            left: -40px;
        }
        &.opened {
            right: 5px;
            .close-section {
                transform: rotate(180deg);
                left: -25px;

            }
        }
    }
    .missing-files-section {
        pointer-events: none;
        opacity: 0.5;
    }
    .notifications {
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        overflow-y: auto;
    }
   
    .dd-status {

        margin-left: 10px;
        padding: 2px 5px;

        border-radius: 5px;
        font-size: 14px;
        font-weight: 600;
        color: white;
        &.dragted, &.submitted {
            background-color: rgba(128, 128, 128, 0.5);
        }
        &.approved {
            background-color: #008000;
        }
        &.rejected {
            background-color: #FF0000;
        }
    }
    .main-container {
        
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        padding-bottom: 50px;
    }
    .table-wrapper {
        width: 100%;
        max-width: 1350px;
    }
    .header-main {
        margin: 0;
        max-width: 1350px;
        
    }
    .section {
        align-items: flex-start;
        background: white;
        border-radius: 8px;
        padding: 20px;
        border: 1px solid var(--border-color);
        box-sizing: border-box;

    }
    .popup-content {
        &:deep(.popup-block) {
            width: 700px;

        }
    }
    .section-header {
        font-size: 16px;
        font-weight: 600;
        padding-left: 15px;
        margin-bottom: 10px;
        text-align: left;
    }
    .markdown-content {
        max-height: 230px;
        height: 250px;
    }
    .info-table {
        text-align: left;
        width: 100%;
        tr {
            td, th {
                padding: 0px;
                border-bottom: 1px solid var(--border-color);

            }
            th {
                vertical-align: top;
                padding-left: 5px;
            }
            td:not(.small) {
                border-left: 1px solid var(--border-color);
                width: 35%;

                &:deep(.styled-input) {
                    margin-bottom: 0;
                }
            }
        }
    }
    .confirm-submit.container {
        width: 600px;
        max-height: 90vh;
        overflow-y: auto;
       
        .save-button {
            width: fit-content;
        }
    }
    .approve-review.container {
        &.missing-files {
            width: 600px;
        }
        width: 450px;
        min-height: unset;
    }

    .width-big {
        max-width: 50%;
    }
    .yes-no {
        td {
            width: 25%;
        }
    }
    .body-content {
        // font-weight: 600;
    }
    input[type="radio"] {
        margin: 0 5px;
        width: 20px;
        height: 25px;
        margin: auto;
        border: unset;
        outline: unset;
    }
    .small[class] {
        padding-top: 4px;
        text-align: center;
    }
    .due-elements {
        display: flex;
        flex-direction: column;
        gap: 100px;
        margin-bottom: 20px;
        width: 100%;
    }
    .save-area {

        position: fixed;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
      
        width: 100%;
        z-index: 1000;

    }
    .save-area-inner {
        position: relative;
        // left: 20px;
        max-width: 1350px;
        width: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        background: white;
        border: 1px solid var(--border-color);
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        justify-content: flex-start;
        align-items: center;
        padding: 5px;
        button {
            height: 35px;
            margin-left: unset;
        }
    }
    .loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
    }
  
    .submit-section {
        max-width: 1350px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
.message-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    padding: 1rem 1.5rem;
}
.message-content {
    font-size: 0.9rem;
    line-height: 1.5rem;
    color: rgb(24 28 34);
    text-align: left;
    &:deep(p) {
        margin: 0;
    }
}

.message-author {
    text-align: left;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    word-break: break-word;
    color: black;
}
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.message-date {
    color: rgb(91 94 102);
    background: rgb(224 226 236);
    border-radius: .125rem;
    height: 1rem;
    text-wrap: nowrap;
    width: fit-content;
    font-size: .75rem;
    font-weight: 700;
    line-height: 1rem;
    padding: .125rem;
}
.message {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: rgb(246 246 252);
    border: 1px solid var(--border-color);
    padding: .75rem;
}
.missing {
    pointer-events: none;
    opacity: 0.5;
}
.border {
    border: 1px solid var(--border-color);
}
.border-red-500[class] {
    border-color: red;
}
.text-red-500 {
    color: red;
    font-size: 10px;
    padding-left: 10px;
}
.border-error {
    border: 1px solid red;
}
.new-value.changes {
        background: #DEF7EC;
    }
    .current.changes {
        background: #FDE8E8;
    }
    .changes {
        tr > th {
            width: 20%;
        }

        tr > td {
            width: 40%;
        }
    }
    .title-change[class] {
        padding: 10px
    }


</style>